module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-section section-15 hidden-xs hidden-sm"
  }, [_c('a', {
    staticClass: "js-pipeline-url-link",
    attrs: {
      "href": _vm.pipeline.path
    }
  }, [_c('span', {
    staticClass: "pipeline-id"
  }, [_vm._v("#" + _vm._s(_vm.pipeline.id))])]), _vm._v(" "), _c('span', [_vm._v("by")]), _vm._v(" "), (_vm.user) ? _c('user-avatar-link', {
    staticClass: "js-pipeline-url-user",
    attrs: {
      "link-href": _vm.pipeline.user.path,
      "img-src": _vm.pipeline.user.avatar_url,
      "tooltip-text": _vm.pipeline.user.name
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.user) ? _c('span', {
    staticClass: "js-pipeline-url-api api"
  }, [_vm._v("\n    API\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label-container"
  }, [(_vm.pipeline.flags.latest) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "js-pipeline-url-latest label label-success",
    attrs: {
      "title": "Latest pipeline for this branch"
    }
  }, [_vm._v("\n      latest\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pipeline.flags.yaml_errors) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "js-pipeline-url-yaml label label-danger",
    attrs: {
      "title": _vm.pipeline.yaml_errors
    }
  }, [_vm._v("\n      yaml invalid\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pipeline.flags.stuck) ? _c('span', {
    staticClass: "js-pipeline-url-stuck label label-warning"
  }, [_vm._v("\n      stuck\n    ")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57efd6e6"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipeline_url.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-57efd6e6"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipeline_url.vue
// module chunks = commit_pipelines pipelines